export default __webpack_public_path__ + "static/media/mailbox-empty.75a5ccaa.svg";